import { Badge } from "antd";
import Icon from "icon";
import { ItemType } from "antd/es/menu/hooks/useItems";
import type { MenuProps } from "antd";
import { Link } from "react-router-dom";
import { Key, ReactNode } from "react";
import i18nNext from "i18n";

interface IRoute {
  label: string;
  path?: string;
  key?: string | number;
  icon?: string;
  dotIcon?: boolean;
  featureKey?: string;
  permissionGroupKey?: string;
  children?: IRoute[] | ItemType[];
}

type MenuItem = Required<MenuProps>["items"][number];

export function getItem(label: ReactNode, key?: Key, icon?: ReactNode, children?: IRoute[]): MenuItem {
  return {
    key,
    icon,
    children,
    label
  } as MenuItem;
}

const getJSONtoRoute = (route: IRoute): MenuItem => {
  const sidebarOption = route.path ? <Link to={route.path}>{i18nNext.t(route.label)}</Link> : i18nNext.t(route.label);

  const icon = route.dotIcon ? (
    <Badge
      color={"black"}
      count={0}
    />
  ) : (
    <Icon
      icon={route?.icon || ""}
      className={"sidebar-icon"}
      disableFill={true}
    />
  );
  return getItem(sidebarOption, route.key, icon, route.children as IRoute[]);
};

export const getPermittedRoute = (
  route: IRoute,
  ActiveFeature: { [x: string]: number | boolean },
  AllowedPermissions: { [x: string]: {} }
): ItemType | undefined => {
  if (!route.permissionGroupKey && !route.featureKey && !route.children) {
    const unAuthRoute = getJSONtoRoute({ ...route, key: route.path });
    return unAuthRoute;
  } else if (route.permissionGroupKey && !route.children) {
    const isActiveRoute = ActiveFeature[route.featureKey as keyof typeof ActiveFeature];
    const isAllowedRoute = AllowedPermissions[route.permissionGroupKey as keyof typeof AllowedPermissions];
    let newRoute;
    if (!!isActiveRoute && !!isAllowedRoute) {
      newRoute = getJSONtoRoute({ ...route, key: route.path });
      return newRoute;
    }
  } else if (route.children) {
    const routePermittedchildren: ItemType[] = [];
    const newRouteWithChildren = { ...route, key: route.path ? route.path : route.label };
    route.children.forEach(routeChild => {
      const child: ItemType | undefined = getPermittedRoute(routeChild as IRoute, ActiveFeature, AllowedPermissions);
      if (child) {
        routePermittedchildren.push(child);
      }
    });
    if (routePermittedchildren.length) {
      newRouteWithChildren.children = routePermittedchildren;
      const children = getJSONtoRoute(newRouteWithChildren);
      return children;
    }
  }
};
